export default (el, { value }) => {
  el.style.transition = 'opacity .2s';
  el.style.opacity = +value ? 1 : 0;
}


// WEBPACK FOOTER //
// ./src/directives/visable.js